import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const TABS = [
    { to: "/admin/tableau-de-bord", label: "Tableau de bord" },
    { to: "/admin/commandes", label: "Commandes" },
    { to: "/admin/audit", label: "Audit mensuel" },
    { to: "/admin/tarifs", label: "Tarifs" },
    { to: "/admin/suggestions", label: "Suggestions" },
    { to: "/admin/flash-info", label: "Flash Info" },
    { to: "/admin/demandes", label: "Demandes" },
    { to: "/admin/membres", label: "Membres" },
    { to: "/admin/logos", label: "Logos clients" },
    { to: "/admin/notifications", label: "Notifications" },
];

export default function AdminLayout() {
    return (
        <section className="max-w-7xl mx-auto px-5 md:px-10 py-10 md:py-14" data-testid="admin-layout">
            <p className="bc-label-small">Administration</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Espace Admin</h1>
            <div className="bc-hairline-gold my-6" />

            <nav className="flex flex-wrap gap-2 md:gap-4 border-b mb-10" style={{ borderColor: "var(--bc-border)" }} data-testid="admin-tabs">
                {TABS.map((t) => (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        className={({ isActive }) =>
                            `px-5 py-3 text-xs uppercase tracking-[0.18em] font-medium border-b-2 transition-colors ${
                                isActive
                                    ? "text-[#D4BC7C] border-[#D4BC7C]"
                                    : "text-[#F2ECE0]/70 border-transparent hover:text-[#D4BC7C]"
                            }`
                        }
                        data-testid={`admin-tab-${t.label.toLowerCase()}`}
                    >
                        {t.label}
                    </NavLink>
                ))}
            </nav>

            <Outlet />
        </section>
    );
}
